var exports = {
  "C": "xae11d333--638e39--categories-row--desktop",
  "Q": "xae11d333--638e39--categories-col--desktop",
};

module.exports = exports;
